import { render, staticRenderFns } from "./CuPager.vue?vue&type=template&id=1aba0cf6&scoped=true"
import script from "./CuPager.vue?vue&type=script&lang=js"
export * from "./CuPager.vue?vue&type=script&lang=js"
import style0 from "./CuPager.vue?vue&type=style&index=0&id=1aba0cf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aba0cf6",
  null
  
)

export default component.exports